// Library
import * as $ from 'jquery';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit, Inject, AfterViewInit, OnChanges, HostListener, OnDestroy } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';

// Service
import { BroadcastService } from './../../../../services/infrastructure/broadcaster.service';
import { ConfigService } from './../../../../services/infrastructure/config.service';
import { DealerService } from './../../../../services/seed/dealer.service';
import { DashboardService } from './../../../../services/seed/dashboard.service';
import { GrowerOrderService } from './../../../../services/seed/growerOrder.service';
import { LocalStorageService } from './../../../../services/infrastructure/local-storage.service';
import { SliderModelService } from './../../../../services/infrastructure/sliderModel.service';
import { CommonService } from './../../../../services/common/common.service';

// View Model
import { MasterConstants } from '../../../../common/constants/master-constants';
import { DashboardFilter } from './../../../../models/DashboardFilter';
import { GrowerOrderData } from './../../../../models/GrowerOrderData';
import { Subscription } from 'rxjs';
import { LolLoggerService } from '../../../../common/shared/lol-logger.service';

@Component({
  selector: 'app-order-view',
  templateUrl: './order-view.component.html',
  styleUrls: ['./order-view.component.scss'],
  animations: [
    trigger('toggleState', [
      state('true', style({ display: 'block' })),
      state('false', style({ display: 'none' })),
      transition('false => true', [style({ maxWidth: '*', width: '*' }), animate(400, style({ maxWidth: '400px', width: '400px' }))]),
      transition('true => false', [style({ maxWidth: '400px', width: '400px' }), animate(400, style({ maxWidth: '*', width: '*' }))])
    ])
  ]
})

export class OrderViewComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  private subscription = new Array<Subscription>();

  SelectedAccountObj: any;
  SelectedGrowerObj: any;
  SelectedDealerOrderAccountNoObj: any;

  SelectedGrowerOrderId: string;
  SelectedAccount: any;
  ddlAccounts: any;
  accountsLoading = false;
  orderViewtoggle = false;
  panelToggle = false;
  isSelected = '0';
  isDealerSelected = '0';
  selectedTabIndex = 0;
  pageName = 'Grower Order';

  // for sorting
  public toggle = true;
  public ToggleData = 'UD';

  growerList: any[];
  accountList: any[];
  accounts: any;
  title: string;
  message: string;
  public accountData: any;
  dealerOrderList: any;
  accountName: string;
  accountId: string;
  showNewGrowerOrder: boolean;
  headerYear: any;
  headerCompany = MasterConstants.US_COMPANYCODE;
  // declare variable for Sorting
  public order = false;
  public selectedItem = 'UD';
  isAddClicked = false;
  public dashboardFilter: DashboardFilter;
  growerObj: GrowerOrderData;
  hasChangeAdded = false;
  userMenuAccessList: any;
  accessTypeMode = false;
  growerAccessTypeMode = false;
  dealerAccessTypeMode = false;
  selectedAccountNo: string;

  constructor(@Inject('BASE_URL') public baseUrl: any,
    private activatedRoute: ActivatedRoute,
    private sliderModelService: SliderModelService,
    private growerOrderService: GrowerOrderService,
    private dashboard: DashboardService,
    private router: Router,
    private configService: ConfigService,
    private dealerService: DealerService,
    private broadcastService: BroadcastService,
    private localStorageService: LocalStorageService,
    public commonService: CommonService,
    private toastrService: ToastrService) {
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }

    this.dashboardFilter = new DashboardFilter();
    this.pageName = 'Grower Order';
    this.subscription.push(this.growerOrderService.SelectedGwrOrderId.subscribe(x => {
      this.SelectedGrowerOrderId = x;
    }));

    if (this.growerOrderService.isGrowerSelectedOnLP) {
      // Get selected Grower obj from the landing page
      const gwrObj = this.growerOrderService.SelectedGrowerObj.value;

      // set Grower order Id in component
      this.SelectedGrowerOrderId = gwrObj.growerOrderId.toString();
    }
    else {
      // set Grower order Id in component
      this.SelectedGrowerOrderId = '0';
    }

    // Set the dealerorderId selected when we click on dealer order on landing page
    this.subscription.push(this.broadcastService.on<any>(this.configService.PARAM_DEALER_ORDER).subscribe((data: any) => {
      if (data.dealerOrderId > 0) {
        this.isDealerSelected = data.dealerOrderId;
      }
      else {
        this.isDealerSelected = data.accountNo;
      }
      this.selectedTabIndex = 1;
      this.pageName = 'Dealer Order';

      if (data.selectedDealerObj != undefined) {
        this.accountName = data.selectedDealerObj.accountName;
        setTimeout(function () {
          if ($('ul.dealersListing li.active') && $('ul.dealersListing li').length && $('.dealersListing li.active').position() != undefined) {
            $('ul.dealersListing').parents('div.mat-mdc-tab-body-content').scrollTop($('.dealersListing li.active').position().top);
          }
        }, 500);
      }
    }));

    // Set the growerorderid selected when we click on grower order on landing page
    this.subscription.push(this.broadcastService.on<any>(this.configService.PARAM_GROWER_ORDER).subscribe((data: any) => {
      this.SelectedGrowerOrderId = data.growerOrderId;
      this.selectedTabIndex = 0;
      this.isDealerSelected = '0';

      this.pageName = 'Grower Order';
      this.subscription.push(this.growerOrderService.getGrowerDetail(this.headerYear, data.accountId, this.SelectedGrowerOrderId).subscribe(result => {
        const growerData = result as GrowerOrderData;
        const growerOrderId = this.activatedRoute.firstChild.snapshot.paramMap.get('growerOrderId');
        if (growerOrderId != '0' && growerData && growerData[0] && growerData[0].growerName != undefined) {
          this.accountName = growerData[0].growerName;
        }
        setTimeout(function () {
          if ($('ul.growersListing li.active') && $('ul.growersListing li').length && $('.growersListing li.active').position() != undefined) {
            $('ul.growersListing').parents('div.mat-mdc-tab-body-content').scrollTop($('.growersListing li.active').position().top);
          }
        }, 500);
      }, (error => {
        LolLoggerService.error(error);
      })));
    }));

    this.subscription.push(this.broadcastService.on<any>(this.configService.DATA_CHANGE_ADDED).subscribe((data) => {
      if (data.hasChangeAdded != undefined) {
        this.hasChangeAdded = data.hasChangeAdded;
      }
    }));

    this.subscription.push(this.router.events.subscribe((e: any) => {
      if (e.shouldActivate != null
        && e.shouldActivate == true) {
        const url = e.url;
        if (this.growerObj != undefined
          && url.indexOf('grower-order-detail') !== -1) {
          this.GrowerNewChange(this.growerObj);
        }
        else if (url.indexOf('dealer-order-view') !== -1) {
          this.dealerNewChange(url.split('/')[4], url.split('/')[5]);
        }
      }

      // If it is a NavigationEnd event re-initalise the component
      if (e instanceof NavigationEnd) {
        // show new grower order button in dealer order screen as well
        this.showNewGrowerOrder = true;// (this.activatedRoute.firstChild.snapshot.url[0].path.indexOf('dealer-order-view') < 0);
        // Get value from route
        const accountId = this.activatedRoute.firstChild.snapshot.paramMap.get('accountNo');
        const growerOrderId = this.activatedRoute.firstChild.snapshot.paramMap.get('growerOrderId');
        this.selectedAccountNo = this.activatedRoute.firstChild.snapshot.paramMap.get('selectedDealerAccountNo');
        this.sliderModelService.selectedAccountId(+accountId);
        if (this.selectedAccountNo != null && this.accountList != null) {
          this.SelectedDealerOrderAccountNoObj = this.accountList.filter(x => x.accountNumber == this.selectedAccountNo);
          if (this.SelectedDealerOrderAccountNoObj != null && this.SelectedDealerOrderAccountNoObj.length > 0 && this.SelectedDealerOrderAccountNoObj[0].wfusB2BEnablement == 'Yes') {
            this.showNewGrowerOrder = false;
          } else { this.showNewGrowerOrder = true; }
        }
        if (accountId && (this.SelectedAccount == 0 || this.SelectedAccount == undefined)) {
          // this.getGrowerAccount(accountId);
          // this.getDealerOrdersList(accountId);
          if (accountId == '0') {
            this.SelectedAccount = new Number();
            this.accountId = '0';
          }
          else {
            this.SelectedAccount = +accountId;
            this.accountId = accountId;
          }
        }
        else {
          if (accountId === '0') {
            this.SelectedAccount = new Number();
            this.accountId = '0';
          }
          else {
            this.SelectedAccount = +accountId;
            this.accountId = accountId;
          }
        }
        if (growerOrderId) {
          this.SelectedGrowerOrderId = growerOrderId;
          this.selectedTabIndex = 0;
          this.isDealerSelected = '0';
        }
      }
    }));

    this.subscription.push(this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationEnd) {
        if (this.localStorageService.get(MasterConstants.HEADER_COMPANY_CODE)) {
          this.headerCompany = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_COMPANY_CODE));
        }

        this.accessTypeMode = false;
        if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
          const evolveAccessData = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
          if (evolveAccessData) {
            this.userMenuAccessList = evolveAccessData.resultData.find(x => x.userIdCompanyCode == this.headerCompany).userMenuAccessList;
            this.accessTypeMode = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.GROWER_ORDERS_TAB, MasterConstants.USER_ACCESS.EDIT_FULL, this.userMenuAccessList);
            this.growerAccessTypeMode = this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.GROWER_ORDERS_TAB);
            this.dealerAccessTypeMode = this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.DEALER_ORDERS_TAB);
          }
        }

        this.reInitialiseOrderViewCmp();
        if (this.isAddClicked) {
          this.resetNewGrowerOrder();
        }
      }
    }));
  }

  ngOnInit() {
    // Get all account list
    this.GetAccountList();
    this.orderContainer();
    this.isAddClicked = false;
    this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    this.headerCompany = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_COMPANY_CODE));
  }

  highlightSelectedGrowerOrder() {
    // Set selected grower order Id
    this.isSelected = this.SelectedGrowerOrderId;
  }

  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setHeight();
  }

  ngOnChanges() {
    this.hasChangeAdded = false;
    this.setHeight();
  }

  // Added Window onresize
  @HostListener('window:resize', ['$event']) onresize(event) {
    this.panelToggle = false;
    this.orderContainer();
    this.setHeight();
  }

  setHeight() {
    const templateHeight = window.innerHeight - $('.grower-left-filter').outerHeight() - $('.mat-mdc-tab-label-container').outerHeight() - 66;
    $('.mat-mdc-tab-body-content').css('height', templateHeight + 'px');
  }

  // Left burger menu toggle functionality
  showSideNav() {
    this.panelToggle = !this.panelToggle;
  }

  // Setting width of right container based on screen resolution
  orderContainer() {
    if ($(window).width() > 1280) {
      this.orderViewtoggle = false;
      this.panelToggle = true;
    } else {
      this.orderViewtoggle = true;
    }
  }

  sortData(Data: string) {
    this.toggle = !this.toggle;
    if (this.ToggleData != Data) {
      this.toggle = false;
      this.order = false;
      this.ToggleData = Data;
    }

    this.selectedItem = Data;
    this.order = !this.order;
    switch (Data) {
      case 'GN':
        {
          if (this.selectedTabIndex == 0) {
            this.growerList.sort((n1, n2) => (this.order) ? n1.growerName.localeCompare(n2.growerName) : n2.growerName.localeCompare(n1.growerName));
            break;
          }
          else if (this.selectedTabIndex == 1) {
            this.dealerOrderList.sort((n1, n2) => (this.order) ? n1.retailerNameCityState.localeCompare(n2.retailerNameCityState) : n2.retailerNameCityState.localeCompare(n1.retailerNameCityState));
            break;
          }
        }
      case 'ON':
        {
          if (this.selectedTabIndex == 0) {
            this.growerList.sort((n1, n2) => (this.order) ? n1.orderID.localeCompare(n2.orderID) : n2.orderID.localeCompare(n1.orderID));
            break;
          }
          else if (this.selectedTabIndex == 1) {
            this.dealerOrderList.sort((n1, n2) => {
              if (n1.orderId == null && n2.orderId == null) { return -1; }
              if (n1.orderId == null && n2.orderId != null) { return 1; }
              if (n1.orderId != null && n2.orderId == null) { return -1; }
              else {
                return (this.order) ? n1.orderId.localeCompare(n2.orderId) : n2.orderId.localeCompare(n1.orderId);
              }
            });
            break;
          }
        }
      case 'UD':
        {
          if (this.selectedTabIndex == 0) {
            this.growerList.sort((n1, n2) => (this.order) ? n1.lastUpdatedAt.localeCompare(n2.lastUpdatedAt) : n2.lastUpdatedAt.localeCompare(n1.lastUpdatedAt));
            break;
          }
          else if (this.selectedTabIndex == 1) {
            this.dealerOrderList.sort((n1, n2) => {
              if (n1.lastUpdatedAt == null && n2.lastUpdatedAt == null) { return -1; }
              if (n1.lastUpdatedAt == null && n2.lastUpdatedAt != null) { return 1; }
              if (n1.lastUpdatedAt != null && n2.lastUpdatedAt == null) { return -1; }
              else {
                return (this.order) ? n1.lastUpdatedAt.localeCompare(n2.lastUpdatedAt) : n2.lastUpdatedAt.localeCompare(n1.lastUpdatedAt);
              }
            });
            break;
          }
        }
      case 'UQ':
        {
          if (this.selectedTabIndex == 0) {
            this.growerList.sort((n1, n2) => (this.order) ? n1.unit - n2.unit : n2.unit - n1.unit);
            break;
          }
          else if (this.selectedTabIndex == 1) {
            this.dealerOrderList.sort((n1, n2) => (this.order) ? n1.units - n2.units : n2.units - n1.units);
            break;
          }
        }
      default: {
        if (this.selectedTabIndex == 0) {
          this.growerList.sort((n1, n2) => (this.order) ? n1.lastUpdatedAt.localeCompare(n2.lastUpdatedAt) : n2.lastUpdatedAt.localeCompare(n1.lastUpdatedAt));
          break;
        }
        else if (this.selectedTabIndex == 1) {
          this.dealerOrderList.sort((n1, n2) => (this.order) ? n1.lastUpdatedAt.localeCompare(n2.lastUpdatedAt) : n2.lastUpdatedAt.localeCompare(n1.lastUpdatedAt));
          break;
        }
      }
    }
  }

  CreateNewOrder() {
    let accountNo = '0';
    if (this.SelectedAccount == null || this.SelectedAccount == '') {
      const selectedAc = this.activatedRoute.firstChild.snapshot.paramMap.get('selectedDealerAccountNo');
      if (selectedAc != null && selectedAc != '') {
        accountNo = selectedAc;
      }
    }
    else {
      accountNo = this.SelectedAccount;
    }
    this.isAddClicked = true;
    this.router.navigate(['/orders/grower-order-add', accountNo]);
  }

  resetNewGrowerOrder() {
    this.isSelected = '0';
    this.SelectedGrowerOrderId = '0';
    this.accountName = '';
  }

  AccountChange($event) {
    if ($event != null && $event.accountNumber != null) {
      if ($event.billingAddressType in MasterConstants.BILLING_ADDRESS_TYPE) {
        this.SetAccount($event.accountNumber);
        this.SelectedAccount = $event.accountNumber;
        this.getDealerOrdersList($event.accountNumber);
        this.getGrowerAccount($event.accountNumber);
      }
      else {
        this.SelectedAccount = null;
        this.toastrService.warning('Account not eligible for Ordering.');
      }
    }
  }

  AccountClear($event) {
    this.growerOrderService.AccountChange(null);
    this.getGrowerAccount('0');
    this.getDealerOrdersList(0);
  }

  GrowerNewChange(newObj: any) {
    this.growerOrderService.GrowerChange({
      growerOrderId: newObj.growerOrderId,
      growerName: newObj.growerName,
      orderID: newObj.orderID,
      growerAddress: newObj.growerAddress,
      city: newObj.city,
      state: newObj.state,
      zipcode: newObj.zip,
      lastUpdatedAt: newObj.lastUpdatedAt,
      accountNo: newObj.accountNo,
      orderType: newObj.orderType,
      gln: newObj.gln,
      gmk: newObj.gmk,
      wfusB2BEnablement: newObj.wfusB2BEnablement
    });
    this.pageName = 'Grower Order';

    this.isSelected = newObj.growerOrderId;
    this.SelectedGrowerOrderId = newObj.growerOrderId;
    this.isAddClicked = false;
  }

  GrowerChange(obj: any) {
    if (obj.growerOrderId) {
      this.sliderModelService.toSellerAccountNo.next(obj.shipToAccount);
      this.growerObj = new GrowerOrderData();
      this.growerObj = obj;
      const accountNumber = this.SelectedAccount;
      if (accountNumber > 0) {
        this.router.navigate(['orders/grower-order-detail', accountNumber, obj.growerOrderId]);
      }
      else {
        this.router.navigate(['orders/grower-order-detail', 0, obj.growerOrderId]);
      }
    }
  }

  SetAccount(accountNumber: string) {
    if (accountNumber != undefined && accountNumber != '') {
      this.SelectedAccountObj = this.accountList.filter(x => x.accountNumber == accountNumber);
    }
  }

  GetAccountList() {
    this.accountsLoading = true;
    this.subscription.push(this.growerOrderService.getAccounts().subscribe((result: any[]) => {
      this.accountList = result;
      this.ddlAccounts = result;
      this.accountsLoading = false;
      this.SelectedDealerOrderAccountNoObj = this.accountList.filter(x => x.accountNumber == this.selectedAccountNo);
      if (this.SelectedDealerOrderAccountNoObj != null && this.SelectedDealerOrderAccountNoObj.length > 0 && this.SelectedDealerOrderAccountNoObj[0].wfusB2BEnablement == 'Yes') {
        this.showNewGrowerOrder = false;
      } else { this.showNewGrowerOrder = true; }
    }, error => LolLoggerService.error(error)));
  }

  getGrowerAccount(accountNo: string) {
    if (accountNo != '') {
      this.dashboardFilter.cropYear = this.headerYear;
      this.dashboardFilter.shipToAccount = +accountNo;
      this.dashboardFilter.gMk = 0;
      if (this.growerAccessTypeMode) {
        this.subscription.push(this.dashboard.getGrowerOrder(this.dashboardFilter).subscribe(result => {
          this.growerList = result as any[];
          this.isSelected = this.SelectedGrowerOrderId;
        }, error => LolLoggerService.error(error)));
      }
    }
  }

  getDealerOrdersList(accountNumber) {
    if (this.dealerAccessTypeMode) {
      this.subscription.push(this.dealerService.getDealerOrdersList(this.headerYear, accountNumber).subscribe(result => {
        this.dealerOrderList = result;
      }, error => LolLoggerService.error(error)));
    }
  }

  dealerNewChange(dealerOrderId: any, shipToAccount: any,) {
    if (dealerOrderId && dealerOrderId != 0) {
      this.isDealerSelected = dealerOrderId;
    }
    else {
      this.isDealerSelected = shipToAccount;
    }
  }

  dealerChange(obj: any) {
    const accountNumber = this.SelectedAccount;
    this.SelectedDealerOrderAccountNoObj = this.accountList.filter(x => x.accountNumber == obj.shipToAccount);
    if (this.SelectedDealerOrderAccountNoObj != null && this.SelectedDealerOrderAccountNoObj.length > 0 && this.SelectedDealerOrderAccountNoObj[0].wfusB2BEnablement == 'Yes') {
      this.showNewGrowerOrder = false;
    } else { this.showNewGrowerOrder = true; }

    if (accountNumber > 0) {
      this.router.navigate(['/orders/dealer-order-view', accountNumber, obj.dealerOrderId, obj.shipToAccount]);
    }
    else {
      this.router.navigate(['/orders/dealer-order-view', 0, obj.dealerOrderId, obj.shipToAccount]);
    }
  }

  accountSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.accountName.toLocaleLowerCase().indexOf(term) > -1
      || item.accountNumber.toString().indexOf(term) > -1
      || item.address1.toLocaleLowerCase().indexOf(term) > -1
      || item.city.toLocaleLowerCase().indexOf(term) > -1
      || item.state.toLocaleLowerCase().indexOf(term) > -1
      || item.zipCode.toLocaleLowerCase().indexOf(term) > -1;
  }

  ngOnDestroy() {
    // avoid memory leaks here by cleaning up after ourselves. If we
    // don't then we will continue to run our initialiseInvites()
    // method on every navigationEnd event.
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }

  navigateToBreadcrumbs() {
    if (this.hasChangeAdded) {
      this.broadcastService.broadcast(this.configService.BREADCRUMB_CLICK, { breadCrumbClick: true });
    }
    else {
      this.broadcastService.broadcast(this.configService.NAVIGATE_TO_BREADCRUMB, { naigateToBreadCrumb: true });
    }

    if (this.pageName == 'Dealer Order') {
      this.broadcastService.broadcast(this.configService.TAB_INDEX, { selectedTabIndex: 1 });
      this.accountName = '';
    }
    else if (this.pageName == 'Grower Order') {
      this.broadcastService.broadcast(this.configService.TAB_INDEX, { selectedTabIndex: 0 });
      this.accountName = '';
    }
  }

  // To reinitialize oninit
  reInitialiseOrderViewCmp() {
    const accountId = this.activatedRoute.firstChild.snapshot.paramMap.get('accountNo');
    const growerOrderId = this.activatedRoute.firstChild.snapshot.paramMap.get('growerOrderId');

    if (accountId && (this.SelectedAccount == 0 || this.SelectedAccount == undefined)) {
      this.getGrowerAccount(accountId);
      if (accountId == '0') {
        this.SelectedAccount = new Number();
      }
      else {
        this.SelectedAccount = +accountId;
      }
    }
    else {
      this.getGrowerAccount(this.SelectedAccount);
    }

    if (growerOrderId) {
      this.SelectedGrowerOrderId = growerOrderId;
    }

    // Set selected grower order Id
    this.highlightSelectedGrowerOrder();
    this.getDealerOrdersList(this.SelectedAccount);
  }

  navigateToLandingPage() {
    this.router.navigate(['/landing-data']);
  }
}
